<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Oficio Voluntario')"
          :directory="app_type"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            Regresar
          </button>
        </div>
      </div>
    </div>
    <app-overlay-loader v-if="preloader" />
    <form
      ref="form"
      data-url="/accreditations/officio/storeFile"
      class="mb-0 mt-4"
      :class="{ 'loading-opacity': preloader }"
    >
      <div class="card card-with-shadow border-0 mb-primary">
        <div class="card-body">
          <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
              <h5 class="card-title m-0">
                Oficio de {{ name_type }} Voluntaria
              </h5>
            </div>
          </div>
          <div>
            <app-note
              class="mb-primary"
              :show-title="false"
              :notes="['Todos los campos con un (*) son obligatorios.']"
            />
          </div>
          <div>
            <div class="form-group">
              <label>Número de Oficio</label>
              <app-input
                type="text"
                v-model="inputs.record"
                placeholder="Al guardar se genera automáticamente"
                class="row col-12 col-md-6"
                :disabled="true"
              />
            </div>
            <div class="form-group">
              <div class="row mb-2">
                <div class="col-6">
                  <label class="mb-1"
                      >Contenido de oficio o solicitud
                      <b class="text-danger ml-2" style="font-size: 18px !important"
                        >*
                      </b>
                    </label>
                </div>
                  <div class="col-6 text-right">
                    <button
                        type="button"
                        class="btn btn-success btn-with-shadow"
                        data-toggle="modal"
                        @click.prevent="
                        openTabPDF(`/common/pdf/voluntaryOffice?accAppId=${accAppId}`)
                      "
                    >
                        Descargar PDF
                    </button>
                </div>
            </div>
          
              <quill-editor
                style="height: 150px"
                v-model="obs.observation"
                :options="editorOption"
                :required="true"
              />
            </div>

            <div class="form-group" style="margin-top: 60px"></div>

            <div class="row mt-4 mb-4">
              <div class="col-12 col-md-8 text-primary">
                <label
                  >Alcances
                  {{
                    name_typem != "reducción" ? " a Suspender" : "a Reducir"
                  }}</label
                >
              </div>
              <div class="col-12 col-md-4">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                  <button
                    type="button"
                    class="btn btn-primary btn-with-shadow"
                    data-toggle="modal"
                    @click="openScopesModal"
                  >
                    Alcances Acreditados
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mt-4">
                <app-table
                  :id="tableId"
                  :options="options"
                  @action="getListAction"
                />
              </div>
            </div>

            <div class="row mt-4 mb-4" v-if="['OENY'].includes(this.codeActivity)">
              <div class="col-12 col-md-8 text-primary">
                <label
                  >Muestreos
                  {{
                    name_typem != "reducción" ? " a Suspender" : "a Reducir"
                  }}</label
                >
              </div>
              <div class="col-12 col-md-4">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                  <button
                    type="button"
                    class="btn btn-primary btn-with-shadow"
                    data-toggle="modal"
                    @click="openSamplingModal"
                  >
                    Muestreos
                  </button>
                </div>
              </div>   
            </div>
            <div div class="row mt-4 mb-4" v-if="['OENY'].includes(this.codeActivity)">
                <officio-sampling-table
                tableId="officio-sampling-table"
                :activity="activity"
                :accAppId="accAppId"
              />
            </div>

            <div class="form-group mt-4">
              <label
                >Justificación de {{ name_typem }} voluntaria<b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*</b
                >
              </label>
              <app-input type="dropzone" v-model="files_1" />

              <p class="text-center text-danger mt-2">
                <small>
                  <strong>Tamaño máximo de cada archivo 8MB</strong>
                </small>
              </p>
            </div>

            <table class="table table-sm table-striped mt-2">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center" style="width: 30%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in inputs.justification_voluntary_officio"
                  :key="key"
                >
                  <td class="align-middle">
                    <small class="text-primary">{{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}</small>
                  </td>
                  <td class="align-middle text-center">
                    <div class="mt-2">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(inputs.justification_voluntary_officio, key)
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                      <button
                        type="submit"
                        class="btn btn-danger"
                        @click.prevent="openDropModal(value.id)"
                      >
                        <app-icon name="trash-2" /> Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="form-group mt-4" v-if="accAreaId == 2">
              <label class="mb-1"
                >Información de certificados emitidos en el mercado<b
                  class="text-danger ml-2"
                  style="font-size: 18px !important"
                  >*</b
                >
              </label>
              <app-input type="dropzone" v-model="files_2" />

              <p class="text-center text-danger mt-2">
                <small>
                  <strong>Tamaño máximo de cada archivo 8MB</strong>
                </small>
              </p>
            </div>
            <table
              class="table table-sm table-striped mt-2"
              v-if="accAreaId == 2"
            >
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center" style="width: 30%">
                    ACCIÓN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(value, key) in inputs.information_certificates_market"
                  :key="key"
                >
                  <td class="align-middle">
                    <small class="text-primary">{{
                      value.path.split("/")[value.path.split("/").length - 1]
                    }}</small>
                  </td>
                  <td class="align-middle text-center">
                    <div class="mt-2">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTab(inputs.information_certificates_market, key)
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                      <button
                        type="submit"
                        class="btn btn-danger"
                        @click.prevent="openDropModal(value.id)"
                      >
                        <app-icon name="trash-2" /> Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="mt-4" />
          <div class="alert alert-warning col-12" role="alert">
            Después de <b>Guardar</b> debe <b>Procesar</b> el registro
          </div>
          <div class="row">
            <div class="col-12 mt-4">
              <button
                type="submit"
                class="btn btn-primary mr-2"
                @click.prevent="submit"
              >
                {{ $t("save") }}
              </button>
              <button
                type="button"
                class="btn btn-success btn-with-shadow ml-3"
                @click="openProcessModal"
              >
                Procesar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <officio-scopes-modal
      v-if="isScopesModalActive"
      :table-id="tableId"
      @close-modal="closeScopesModal"
      :activity="activity"
      :activityId="activityId"
      :userId="userId"
      :accAppId="accAppId"
    />

    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="application-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea deshacer este registro?"
    />

    <app-confirmation-modal
      v-if="processConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="processConfirmed"
      @cancelled="processCancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="deleteConfirmed"
      @cancelled="deleteCancelled"
    />
    <div v-if="['OENY'].includes(this.codeActivity)">
      <officio-sampling-modal
        v-if="isSamplingModalActive"
        tableId="officio-sampling-table"
        @close-modal="closeSamplingModal"
        :activity="activity"
        :activityId="activityId"
        :userId="userId"
        :accAppId="accAppId"
      />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { quillEditor } from "vue-quill-editor";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [FormMixin, TableHelpers],
  components: { quillEditor },

  props: {
    accAppId: String,
    codeActivity: String,
    actId: String,
    accAreaId: String,
  },
  data() {
    return {
      deleteLoader: false,
      preloader: false,
      app_type: "",
      name_type: "",
      name_typem: "",
      activity: "",
      activityId: "",
      userId: "",
      inputs: {},
      obs: {},
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
      files_1: [],
      files_2: [],
      tableId: "accredited-scopes-table",
      rowData: {},
      options: {
        url: `/accreditations/officio/showEditScopes/${this.accAppId}?activityId=${this.actId}`,
        name: "",
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Deshacer"),
            icon: "trash",
            type: "none",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      isScopesModalActive: false,
      isSamplingModalActive: false,
      deleteConfirmationModalActive: false,
      processConfirmationModalActive: false,
      deleteModal: false,
      file_id:"",
    };
  },
  created() {
    this.$store.state.accreditation.id = this.accAppId;
    this.data();
    this.dataInfo();

    // this.options.columns = [...this.tableColumns, this.actionObj];
    let columns = [];
    if (["OCPR"].includes(this.codeActivity)) columns = this.OCPR;
    else if (["CSGAS"].includes(this.codeActivity)) columns = this.CSGAS;
    else if (["OCSG", "CSA"].includes(this.codeActivity)) columns = this.OCSG;
    else if (["CSIA"].includes(this.codeActivity)) columns = this.CSIA;
    else if (["OCPE"].includes(this.codeActivity)) columns = this.OCPE;
    else if (["OINSP"].includes(this.codeActivity)) columns = this.OINSP;
    else if (["OENY"].includes(this.codeActivity)) columns = this.OENY;
    else if (["OICC"].includes(this.codeActivity)) columns = this.OICC;
    else if (["OCLN"].includes(this.codeActivity)) columns = this.OCLN;
    else if (["OEYC"].includes(this.codeActivity)) columns = this.OEYC;
    else if (["OEAP"].includes(this.codeActivity)) columns = this.OEAP;

    this.options.columns = [...columns, this.actionObj];
  },

  watch: {
    "$store.state.accreditation.app": function () {
      const {
        accreditation_area: area,
        accreditation_activity: activity,
        accreditation_type: type,
        user: user,
      } = this.$store.state.accreditation.app;

      this.app_type = `${area.name} - ${activity.name}`;
      this.name_type = `${type.name}`;
      this.name_typem = this.name_type.toLocaleLowerCase();
      this.activity = `${activity.code}`;

      this.activityId = activity.id;
      this.userId = user.id;
    },
  },
  methods: {
    data() {
      this.$store.dispatch("getAccApp");
    },

    dataInfo() {
      this.preloader = true;

      this.axiosGet(`accreditations/officio/showDataOficio/${this.accAppId}`)
        .then((response) => {
          if (response.status == 200 && response.data) {
            const { accApp, obs } = response.data;
            this.inputs = accApp;
            if (obs) this.obs = obs;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    returnPage() {
      window.location.href = `/accreditations/officio`;
    },
    submit() {
      if (!this.obs.observation || (this.files_1.length == 0 && this.inputs.justification_voluntary_officio.length == 0 )) {
        this.$toastr.e("Todos los campos con un (*) son obligatorios.");
        return;
      } else if (this.accAreaId == 2 && this.files_2.length == 0 && this.inputs.information_certificates_market.length == 0) {
        this.$toastr.e("Todos los campos con un (*) son obligatorios.");
        return;
      }

      if (
        (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) ||
        (this.files_2.length > 0 && this.validateFileSize(this.files_2) > 0)
      ) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 8MB");
        return;
      }
      let formData = new FormData();

      // formData.append("accApp", JSON.stringify(this.inputs));
      formData.append("obs", JSON.stringify(this.obs));

      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.files_2.forEach((file) => {
        formData.append("files_2[]", file);
      });

      formData.append("acc_app_id", this.accAppId);

      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.$toastr.s(this.$t("updated_success"));
      this.files_1 = [];
      this.files_2 = [];
      this.dataInfo();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("Deshacer")) {
        this.openDeleteModal();
      }
    },

    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `/accreditations/officio/destroyScope/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#application-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(this.$t("deleted_success"));
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
    },

    openScopesModal() {
      this.isScopesModalActive = true;
    },

    openSamplingModal() {
      this.isSamplingModalActive = true;
    },

    closeScopesModal() {
      $("#officio-scopes-modal").modal("hide");
      this.isScopesModalActive = false;
      // this.reSetData();
    },
    closeSamplingModal() {
      $("#officio-sampling-modal").modal("hide");
      this.isSamplingModalActive = false;
      // this.reSetData();
    },
    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 8000000) {
          return file;
        }
      }).length;
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    openTabPDF(path) {
      window.open(path, "_blank").focus();
    },
    openProcessModal() {
        this.processConfirmationModalActive = true;
    },
    processConfirmed() {
        this.preloader = true;
        axiosPost(
            `/accreditations/officio/process/${this.accAppId}`
        ).then((response) => {
            if (response.data.status == true) {
            this.deleteLoader = false;
            $("#modal-confirm-id").modal("hide");
            this.cancelled();
            if (response.data.data === "OK") {
                this.$toastr.s("Registro procesado con exito");
                this.returnPage();
                this.preloader = false;
            } else {
                this.$toastr.e(response.data.data);
                this.preloader = false;
            }
            }
        });
    },
    processCancelled() {
        this.processConfirmationModalActive = false;
    },
    openDropModal(id) {
      this.deleteModal = true;
      this.file_id = id;
    },
    deleteCancelled() {
      this.deleteModal = false;
    },
    deleteConfirmed() {
      const url = `/accreditations/officio/destroyfile/${this.file_id}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.file_id = "";
          this.dataInfo();
        });
    }
  },
};
</script>

<style>
</style>
